import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import content from './config/data/table/content.csv';
import boardType from './config/data/table/BoardType.csv';
import boardCustomType from './config/data/table/boardCustomType.csv';
import sns from './config/data/table/sns.csv';
import watch from './config/data/table/watch.csv';
import overseas_en from './config/data/table/overseas_en.csv';
import overseas_ko from './config/data/table/overseas_ko.csv';
import department from './config/data/table/department.csv';
import loadCustomer from './localization/csv_convert';
import setTableDataFile from './localization/data_read';
import { Mki18n } from './localization/i18n';
import Structure from './routes/Structure';
import ErrorPage from './routes/common/ErrorPage';

// 아래 useQuery 호출들은 반환값을 컴포넌트에서 직접 쓰지 않지만
// 절대 지우면 안 됩니다.
// react-query 캐시에 테이블 CSV 데이터를 채우는 용도이며,
// 각 페이지 컴포넌트는 useContent(key)로 이 캐시를 조회해서 사용합니다.
// 추후 미사용 .csv 파일은 제거 해야합니다.
const useTableCache = () => {
  useQuery('content', () => setTableDataFile(content), { staleTime: Infinity, cacheTime: Infinity });
  useQuery('boardType', () => setTableDataFile(boardType), { staleTime: Infinity, cacheTime: Infinity });
  useQuery('boardCustomType', () => setTableDataFile(boardCustomType), { staleTime: Infinity, cacheTime: Infinity });
  useQuery('sns', () => setTableDataFile(sns), { staleTime: Infinity, cacheTime: Infinity });
  useQuery('watch', () => setTableDataFile(watch), { staleTime: Infinity, cacheTime: Infinity });
  useQuery('overseas_en', () => setTableDataFile(overseas_en), { staleTime: Infinity, cacheTime: Infinity });
  useQuery('overseas_ko', () => setTableDataFile(overseas_ko), { staleTime: Infinity, cacheTime: Infinity });
  useQuery('department', () => setTableDataFile(department), { staleTime: Infinity, cacheTime: Infinity });
};

const App = () => {
  let { mode } = useSelector((state) => state);

  const { data, error } = useQuery('localText', loadCustomer, {
    suspense: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  useTableCache();

  useEffect(() => {
    if (data) Mki18n(data, mode);
  }, [data, mode]);

  if (error) {
    return <ErrorPage error={error.code} errorInfo={error.message}></ErrorPage>;
  }

  return (
    <Router forceRefresh={false}>
      <Structure mode={mode} />
    </Router>
  );
};

export default withTranslation()(App);
